<template>
    <div class="center">
        <div class="row">
            <div class="col-md-12">
                <loading :active.sync="loading" :is-full-page="fullPage" color="#016BAB"></loading>
                <form class="login" method="post" :action="action">
                    <h2 style="text-align: center;padding-top: 50px;">Xstek Client Window</h2>
                    <div class="form-group">
                        <label v-show="isInvalid" class="error--text font-weight-bold">Invalid user authentication.</label>
                    </div>
                    <div class="form-group">
                        <label for="username">Login ID</label>
                        <input required name="usr" v-model="userId" type="text" placeholder="Login ID" class="form-control" />
                    </div>
                    <div class="form-group">
                        <label>Password</label>
                        <input required name="pwd" v-model="userPassword" type="password" placeholder="Password" class="form-control" />
                    </div>
                    <div class="form-group" style="text-align:center">
                        <button type="submit" class="btn btn-primary">Login</button>
                    </div>
                </form>
            </div>
            <div class="col-md-12 text-center">
                Copyright &copy; Xstek Ltd. All Rights Reserved.
            </div>
        </div>
    </div>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    export default {
        data() {
            return {
                email: "",
                userPassword: "",
                userId: "",
                loggingIn: true,
                fullPage: true,
                loading: false,
                isInvalid: false,
                action: process.env.VUE_APP_LOGIN_URL,
            }
        },
        components: {
            Loading
        },
        methods: {
            login: function() {
                let userId = this.userId
                let userPassword = this.userPassword
                this.loading = true;
                this.$store.dispatch('login', { userId, userPassword })
                    .then(() => {
                        try {
                            let returnUrl = sessionStorage.getItem("returnUrl");
                            if (returnUrl) {
                                this.$router.push(returnUrl)
                            } else {
                                this.$router.push('/')
                            }
                        } finally {
                            sessionStorage.removeItem("returnUrl");
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.isInvalid = true;
                        setTimeout(() => {
                            this.isInvalid = false;
                        }, 1000);
                    });
            }
        }
    }
</script>
<style scoped>
    .center {
        margin: auto;
        width: 50%;
        padding: 10px;
    }
</style>